import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MapPin, Users, ScanLine, ShieldCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { FieldSitesManager } from "./FieldSitesManager";
import { FieldGroupsManager } from "./FieldGroupsManager";
import { LeaderScanPanel } from "./LeaderScanPanel";
import { StaffRotationScanPanel } from "./StaffRotationScanPanel";

const STAFF_ROLES = [
  "superadmin",
  "it_incharge",
  "head_academic",
  "head_administration",
  "principal",
  "deputy_principal",
  "hod_cmt",
  "hod_pst",
  "hod_sw",
] as const;

export function RotationTab() {
  const { hasRole } = useAuth();
  const isStaff = STAFF_ROLES.some((r) => hasRole(r));

  // Non-staff (students / leaders) only see the leader scan view
  if (!isStaff) {
    return <LeaderScanPanel />;
  }

  return (
    <Tabs defaultValue="staff-scan" className="space-y-4">
      <div className="overflow-x-auto -mx-1 px-1">
        <TabsList className="inline-flex w-max">
          <TabsTrigger value="staff-scan" className="whitespace-nowrap">
            <ShieldCheck className="w-4 h-4 mr-1" /> Staff Scan
          </TabsTrigger>
          <TabsTrigger value="groups" className="whitespace-nowrap">
            <Users className="w-4 h-4 mr-1" /> Groups
          </TabsTrigger>
          <TabsTrigger value="sites" className="whitespace-nowrap">
            <MapPin className="w-4 h-4 mr-1" /> Field Sites
          </TabsTrigger>
        </TabsList>
      </div>
      <TabsContent value="staff-scan"><StaffRotationScanPanel /></TabsContent>
      <TabsContent value="groups"><FieldGroupsManager /></TabsContent>
      <TabsContent value="sites"><FieldSitesManager /></TabsContent>
    </Tabs>
  );
}
